<template>
    <div class="plan-forcast-update clearfix">
        <compWrapper title="Base Infomation" theme="primary">
            <compFormQuery
                v-if="type == 'query'"
                :col="1"
                class="margin-15 width-60per"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                :col="1"
                class="margin-15 width-60per"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            ></compFormEdit>
        </compWrapper>
        <compWrapper v-if="type != 'edit'" title="操作历史" theme="gray">
            <compLog :data="logList" ></compLog>
        </compWrapper>
        <div class="margin-20 pull-right">
            <Button v-if="type == 'edit'" class="margin-right-15" type="primary" @click="submit">保存</Button>
            <Button type="default" @click="cancel">返回</Button>
        </div>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show=false"
            @on-confirm="modalProps.show=false"
        >
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps.props"
                @on-close="modalProps.show=false"
                v-on="modalProps.on"
            />
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import {
    HttpGetForcast,
    HttpUpdateForcast,
    HttpBISysOpLog
} from "@/service/purchase/purchase.js"
import compProduct from "@/views/products/allproducts/update";
import mixin from "./mixin";
export default {
    props: ['activeid', 'querytype'],
    mixins: [mixin],
    components: {
        compProduct
    },
    data () {
        return {
            id: this.activeid ? this.activeid : this.$route.query.id,
            type: this.$route.params.type || this.querytype,
            loading: false,
            formData: {},
            logList: [],
            modalProps: {
                show: false
            }
        }
    },
    async created () {
        this.loading = true;
        await this.getDetail();
        if (this.type != 'edit') {
            await this.getLog();
        }
        this.loading = false;
    },
    computed: {
        getBase () {
            return [
                {
                    label: 'ERP SKU',
                    key: 'erpsku',
                    query: true,
                    render: (h) => {
                        return <a class="font-bold" onClick={this.handleProduct}>{this.formData.erpsku}</a>
                    },
                },
                {
                    label: 'Demand Class',
                    key: 'demandClass',
                    // query: true,
                    render: (h) => {
                        console.log(this.demandClassList);
                        let demandItem = this.demandClassList.filter(item => {
                            return item.value === this.formData.demandForecastClassId
                        })[0];
                        return (
                            <div>
                                {demandItem ? demandItem.label : '--'}
                            </div>
                        )
                    },
                    tag: "div",
                    children: (h) => {
                        console.log(this.demandClassList);
                        let demandItem = this.demandClassList.filter(item => {
                            return item.value === this.formData.demandForecastClassId
                        })[0];
                        return (
                            <div class="font-bold">
                                {demandItem ? demandItem.label : '--'}
                            </div>
                        )
                    },
                    required: false
                },
                {
                    label: 'Time Bucket',
                    render: (h) => {
                        return 'Week';
                    },
                    tag: "div",
                    children: (h) => {
                        return <div class="font-bold">Week</div>
                    },
                    required: false
                },
                {
                    label: 'Start Date',
                    query: true,
                    key: 'startDate'
                },
                {
                    label: 'End Date',
                    query: true,
                    key: 'endDate'
                },
                {
                    label: 'Bucket',
                    // query: true,
                    render: (h) => {
                        return <div>{`${this.formData.startYear}-${this.formData.startWeek}W ~ ${this.formData.endYear}-${this.formData.endWeek}W`}</div>
                    },
                    tag: "div",
                    children: (h) => {
                        return <div class="font-bold">{`${this.formData.startYear}-${this.formData.startWeek}W ~ ${this.formData.endYear}-${this.formData.endWeek}W`}</div>
                    },
                    required: false
                },
                {
                    label: 'Number of Buckets',
                    query: true,
                    key: 'bucket'
                },
                {
                    label: 'Qty/Bucket',
                    key: 'quantity',
                    tag: "vInputNumber",
                    props: {
                        min: 0,
                        precision: 0
                    },
                },
                {
                    label: 'Total Qty',
                    // query: true,
                    key: 'totalQuantity',
                    tag: "div",
                    children: (h) => {
                        return <div class="font-bold">{this.formData.quantity * this.formData.bucket}</div>
                    },
                    required: false
                },
                {
                    label: 'Remark',
                    key: 'remark',
                    required: false,
                    tag: 'vTextarea'
                }
            ]
        },
    },
    methods: {
        async submit () {
            await this.$refs.editform.validate();
            this.loading = true;
            await HttpUpdateForcast({
                id: this.id,
                quantity: this.formData.quantity,
                remark: this.formData.remark
            }).then(res => {
                this.$VMessage.success(res.message);
                this.cancel();
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
        cancel () {
            // if (this.type == 'edit') {
            //     this.$router.push({
            //         name: "planForcast"
            //     });
            // }
            // else {
                this.$emit('on-close');
            // }
        },
        async getDetail () {
            await HttpGetForcast({
                id: this.id
            }).then(res => {
                console.log('res', res);
                this.formData = res.data;
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
        handleProduct () {
            this.modalProps = {
                show: true,
                title: this.$t("global.common.operation_see", { defaultValue: '查看' }),
                show: true,
                width: 1200,
                component: "compProduct",
                props: {
                activeids: this.formData.productId,
                querytype: 'query',
                },
                showFooter: false
            };
        },
        async getLog () {
            await HttpBISysOpLog({
                search: {
                    'EQ_opData': this.id,
                    'EQ_opModel': "ForecastDemand"
                }
            }).then(res => {
                this.logList = res.data.content;
            }, err => {
                this.$VMessage.error(err.message);
            });
        },
    }
};
</script>

<style>
</style>